<template>
  <div class="import-export-module-page page">
    <router-view />
  </div>
</template>
<script>
import accessories from "@/packages/dataFiles/accessories.json";
import cess from "@/packages/dataFiles/cess.json";
import units from "@/packages/dataFiles/units.json";
import cities from "@/packages/dataFiles/cities.json";
import states from "@/packages/dataFiles/states.json";
import containerSealTypes from "@/packages/dataFiles/containerSealTypes.json";
import containerSizes from "@/packages/dataFiles/containerSizes.json";
import containerTypes from "@/packages/dataFiles/containerTypes.json";
import districtCodes from "@/packages/dataFiles/districtCodes.json";
import country from "@/packages/dataFiles/Country.json";
import currency from "@/packages/dataFiles/currency.json";
import declarations from "@/packages/dataFiles/declarations.json";
import rodteps from "@/packages/dataFiles/rodtep.json";
import endUses from "@/packages/dataFiles/endUses.json";
import exporterTypes from "@/packages/dataFiles/exporterTypes.json";
import exportUnders from "@/packages/dataFiles/exportUnders.json";
import goodsStuffedAt from "@/packages/dataFiles/goodsStuffedAt.json";
import gstInTypes from "@/packages/dataFiles/gstInTypes.json";
import igstPaymentStatus from "@/packages/dataFiles/igstPaymentStatus.json";
import natureOfCargo from "@/packages/dataFiles/natureOfCargo.json";
import sealTypes from "@/packages/dataFiles/sealTypes.json";
import shipmentTypes from "@/packages/dataFiles/shipmentTypes.json";
import showFOBIns from "@/packages/dataFiles/showFOBIns.json";
import natureOfPayments from "@/packages/dataFiles/natureOfPayments.json";
import termsOfInvoices from "@/packages/dataFiles/termsOfInvoices.json";
import unitPriceIncludes from "@/packages/dataFiles/unitPriceIncludes.json";
import eximSchemeCodes from "@/packages/dataFiles/eximSchemeCodes.json";
import ritcCodes from "@/packages/dataFiles/ritcCodes.json";
import foreignPorts from "@/packages/dataFiles/foreignPorts.json";
import ptaFtas from "@/packages/dataFiles/ptaFtas.json";
import homePorts from "@/packages/dataFiles/homePorts.json";
import drawbackRates from "@/packages/dataFiles/drawbackRates.json";
import * as AT from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";

export default {
  name: "ImportExportModule",
  created() {
    this.storeAccessories();
    this.storeCess();
    this.storeContainers();
    this.storeCountries();
    this.storeCurrencies();
    this.storeDeclarations();
    this.storeRodteps();
    this.storeEndUses();
    this.storeExports();
    this.storeGoodsStuffedAt();
    this.storeGSTInTypes();
    this.storeIgstPaymentStatus();
    this.storeNatureOfCargo();
    this.storeSealTypes();
    this.storeDistrictCodes();
    this.storeShipments();
    this.storeShowFOBIns();
    this.storeNatureOfPayments();
    this.storeTermsOfInvoices();
    this.storeUnitPriceIncludes();
    this.storeUnits();
    this.storeCities();
    this.storeStates();
    this.storeEximSchemeCodes();
    this.storeRitcCodes();
    this.storeForeignPorts();
    this.storeHomePorts();
    this.storePtaFtas();
    this.storeDrawbackRates();
  },
  methods: {
    storeAccessories() {
      let accessoriesData = {
        accessories: accessories.accessories
      };
      this.$store.dispatch(AT.STORE_ACCESSORIES, accessoriesData);
    },
    storeCities() {
      const citiesState = this.$store.getters.cities;
      if (citiesState === null || citiesState.length === 0) {
        let citiesData = {
          cities: cities.cities
        };
        this.$store.dispatch(AT.STORE_CITIES, citiesData);
      }
    },
    storeStates() {
      const statesState = this.$store.getters.states;
      if (statesState === null || statesState.length === 0) {
        let statesData = {
          states: states.states
        };
        this.$store.dispatch(AT.STORE_STATES, statesData);
      }
    },
    storeUnits() {
      let unitsData = {
        units: units.units
      };
      this.$store.dispatch(AT.STORE_UNITS, unitsData);
    },
    storeCess() {
      let cessData = {
        cess: cess.cess
      };
      this.$store.dispatch(AT.STORE_CESS, cessData);
      let cessGeneralDutyData = {
        cessGeneralDuty: cess.cessGeneralDuty
      };
      this.$store.dispatch(AT.STORE_CESS_GENERAL_DUTY, cessGeneralDutyData);
    },
    storeContainers() {
      let containerSealTypesData = {
        containerSealTypes: containerSealTypes.containerSealTypes
      };
      this.$store.dispatch(AT.STORE_CONTAINER_SEAL_TYPES, containerSealTypesData);
      let containerSizesData = {
        containerSizes: containerSizes.containerSizes
      };
      this.$store.dispatch(AT.STORE_CONTAINER_SIZES, containerSizesData);
      let containerTypesData = {
        containerTypes: containerTypes.containerTypes
      };
      this.$store.dispatch(AT.STORE_CONTAINER_TYPES, containerTypesData);
    },
    storeDistrictCodes() {
      let districtCodeData = {
        districtCodes: districtCodes
      };
      this.$store.dispatch(AT.STORE_DISTRICT_CODES, districtCodeData);
    },
    storeCountries() {
      let countryData = {
        countries: country.country
      };
      this.$store.dispatch(AT.STORE_COUNTRIES, countryData);
    },
    storeCurrencies() {
      let currenciesData = {
        currencies: currency.currency
      };
      this.$store.dispatch(AT.STORE_CURRENCIES, currenciesData);
    },
    storeDeclarations() {
      let declarationsData = {
        declarations: declarations.declarations
      };
      this.$store.dispatch(AT.STORE_DECLARATIONS, declarationsData);
    },
    storeRodteps() {
      let rodtepsData = {
        rodteps: rodteps.rodteps
      };
      this.$store.dispatch(AT.STORE_RODTEPS, rodtepsData);
    },
    storeEndUses() {
      let endUsesData = {
        endUses: endUses.endUses
      };
      this.$store.dispatch(AT.STORE_END_USES, endUsesData);
    },
    storeExports() {
      let exporterTypesData = {
        exporterTypes: exporterTypes.exporterTypes
      };
      this.$store.dispatch(AT.STORE_EXPORTER_TYPES, exporterTypesData);
      let exportUndersData = {
        exportUnders: exportUnders.exportUnders
      };
      this.$store.dispatch(AT.STORE_EXPORT_UNDERS, exportUndersData);
    },
    storeGoodsStuffedAt() {
      let goodsStuffedAtData = {
        goodsStuffedAt: goodsStuffedAt.goodsStuffedAt
      };
      this.$store.dispatch(AT.STORE_GOODS_STUFFED_AT, goodsStuffedAtData);
    },
    storeGSTInTypes() {
      let gstInTypesData = {
        gstInTypes: gstInTypes.gstInTypes
      };
      this.$store.dispatch(AT.STORE_GST_IN_TYPES, gstInTypesData);
    },
    storeIgstPaymentStatus() {
      let igstPaymentStatusData = {
        igstPaymentStatus: igstPaymentStatus.igstPaymentStatus
      };
      this.$store.dispatch(AT.STORE_IGST_PAYMENT_STATUS, igstPaymentStatusData);
    },
    storeNatureOfCargo() {
      let natureOfCargoData = {
        natureOfCargo: natureOfCargo.natureOfCargo
      };
      this.$store.dispatch(AT.STORE_NATURE_OF_CARGO, natureOfCargoData);
    },
    storeSealTypes() {
      let sealTypesData = {
        sealTypes: sealTypes.sealTypes
      };
      this.$store.dispatch(AT.STORE_SEAL_TYPES, sealTypesData);
    },
    storeShipments() {
      let shipmentTypesData = {
        shipmentTypes: shipmentTypes.shipmentTypes
      };
      this.$store.dispatch(AT.STORE_SHIPMENT_TYPES, shipmentTypesData);
    },
    storeShowFOBIns() {
      let showFOBInsData = {
        showFOBIns: showFOBIns.showFOBIns
      };
      this.$store.dispatch(AT.STORE_SHOW_FOB_INS, showFOBInsData);
    },
    storeNatureOfPayments() {
      let natureOfPaymentsData = {
        natureOfPayments: natureOfPayments.natureOfPayments
      };
      this.$store.dispatch(AT.STORE_SHOW_NATURE_OF_PAYMENTS, natureOfPaymentsData);
    },
    storeTermsOfInvoices() {
      let termsOfInvoicesData = {
        termsOfInvoices: termsOfInvoices.termsOfInvoices
      };
      this.$store.dispatch(AT.STORE_TERMS_OF_INVOICES, termsOfInvoicesData);
    },
    storeUnitPriceIncludes() {
      let unitPriceIncludesData = {
        unitPriceIncludes: unitPriceIncludes.unitPriceIncludes
      };
      this.$store.dispatch(AT.STORE_UNIT_PRICE_INCLUDES, unitPriceIncludesData);
    },
    storeEximSchemeCodes() {
      let eximSchemeCodesData = {
        eximSchemeCodes: eximSchemeCodes.eximSchemeCodes
      };
      this.$store.dispatch(AT.STORE_EXIM_SCHEME_CODES, eximSchemeCodesData);
    },
    storeRitcCodes() {
      let ritcCodesData = {
        ritcCodes: ritcCodes.ritcCode
      };
      this.$store.dispatch(AT.STORE_RITC_CODES, ritcCodesData);
    },
    storeForeignPorts() {
      let foreignPortsData = {
        foreignPorts: foreignPorts.foreignPorts
      };
      this.$store.dispatch(AT.STORE_FOREIGN_PORTS, foreignPortsData);
    },

    storeHomePorts() {
      let homePortsData = {
        homePorts: homePorts.homePorts
      };
      this.$store.dispatch(AT.STORE_HOME_PORTS, homePortsData);
    },
    storePtaFtas() {
      let ptaFtasData = {
        ptaFtas: ptaFtas.ptaFtas
      };
      this.$store.dispatch(AT.STORE_PTA_FTAS, ptaFtasData);
    },
    storeDrawbackRates() {
      let drawbackRatesData = {
        drawbackRates: drawbackRates.drawbackRates
      };
      this.$store.dispatch(AT.STORE_DRAW_BACK_RATES, drawbackRatesData);
    }
  }
};
</script>
